import React from 'react';
import classes from "./TabBar.module.scss";
import { TeacherRole } from "../../../shared/types/teacher";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../shared/hooks/useAppSelector";

export interface TabItem {
    name: string;
    path: string;
    visible: boolean;
}

const TabBar = () => {
    const navigate = useNavigate();
    const {currentTeacher} = useAppSelector(state => state.auth);

    const tabs: TabItem[] = [
        {name: 'Ученики', path: '/students', visible: true},
        {name: 'Учителя', path: '/teachers', visible: currentTeacher?.role === TeacherRole.ADMIN},
        {name: 'Договоры', path: '/agreements', visible: true},
        {name: 'Отчеты', path: '/reports', visible: true},
        {name: 'Конфигурация', path: '/configurations', visible: currentTeacher?.role === TeacherRole.ADMIN},
    ];

    return (
        <div className={classes.tabBar}>
            {tabs.map((tab) => (
                tab.visible && (
                    <div
                        key={tab.name}
                        className={`
                      ${classes.tab} 
                      ${window.location.pathname.startsWith(tab.path) ? classes.active : ''}
                    `}
                        onClick={
                            () => navigate(tab.path)
                        }
                    >
                        {tab.name}
                    </div>
                )
            ))}
        </div>
    );
};

export default TabBar;